import type { CheckboxProps } from '@launchpad-ui/components';
import { Checkbox as LaunchpadCheckbox } from '@launchpad-ui/components';

import { useFieldContext } from '../../contexts';

import { FormFieldError } from './FormFieldError';

export function Checkbox(props: CheckboxProps) {
  const field = useFieldContext<boolean>();
  const isInvalid = field.state.meta.isTouched && field.state.meta.errors.length > 0;

  return (
    <LaunchpadCheckbox
      isInvalid={isInvalid}
      isSelected={field.state.value}
      onChange={(val: boolean) => {
        field.handleChange(val);
      }}
      onBlur={() => {
        field.handleBlur();
      }}
      name={field.name}
      {...props}
    >
      {(renderProps) => (
        <>
          {typeof props.children === 'function' ? props.children(renderProps) : props.children}
          <FormFieldError meta={field.state.meta} />
        </>
      )}
    </LaunchpadCheckbox>
  );
}
